"use strict";Object.defineProperty(exports, "__esModule", { value: true });exports.default = void 0;









































































































var _formatter = require("@/utils/formatter"); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = { data: function data() {return { tableData: [], // 列表数据
      droplist: [], // 表格列
      tableColumns: [{ prop: 'appName', label: 'app', isShow: true }, { prop: 'appVersion', label: 'APP版本号', isShow: true }, { prop: 'phoneId', label: '手机标示', isShow: true }, { prop: 'mac', label: 'mac地址', isShow: true }, { prop: 'phoneIp', label: '手机ip', isShow: true }, { prop: 'sysType', label: '系统类型', formatter: _formatter.sysTypeFormatter, isShow: true }, { prop: 'sysVersion', label: '系统版本', isShow: true }, { prop: 'province', label: '省', isShow: true }, { prop: 'city', label: '市', isShow: true }, { prop: 'lastTime', label: '创建时间', isShow: true, formatter: _formatter.dateFormatter }], searchData: { appId: '', appVersion: '', phoneId: '', sysType: '', page: 1, // 当前页码
        rows: 10 // 页码条数
      }, pageData: { page: 1, rows: 10, total: 0, pages: 1 }, addpageData: { page: 1, rows: 10, total: 0, pages: 1 } };}, mounted: function mounted() {var self = this;self.init();self.getdrop();}, methods: { init: function init() {var self = this;self.getData('/api/logAppVersion', self.searchData, function (res) {self.tableData = res.list;self.pageData.page = res.pageNum;self.pageData.total = res.total;});}, resetFun: function resetFun() {// 重置
      this.searchData.appId = '';this.searchData.appVersion = '';this.searchData.phoneId = '';this.searchData.sysType = '';this.init();}, searchFun: function searchFun() {// 搜索事件
      this.searchData.page = 1;this.init();}, handleSizeChange: function handleSizeChange(val) {// 分页条数
      this.searchData.rows = val;
      this.searchData.page = 1;
      this.init();
    },
    handleCurrentChange: function handleCurrentChange(val) {// 分页页码
      this.searchData.page = val;
      this.init();
    },
    changeopenMethodFun: function changeopenMethodFun(val) {
      var self = this;
      self.searchData.sysType = '';
      if (val === '1') {
        self.searchData.sysType = '1';
      } else if (val === '2') {
        self.searchData.sysType = '2';
      } else if (val === '3') {
        self.searchData.sysType = '3';
      }
    },
    getdrop: function getdrop() {
      var self = this;
      self.getData('/api/appVersion/apps', {}, function (res) {
        self.droplist = res;
        console.log(res);
      });
    } } };exports.default = _default;